import { Transformers } from '@enterprise/common';
import { pick } from 'lodash';
import { AutoCalculatePrice, InvoiceItem, InvoiceItemTypes, InvoiceItemWithDynamicProps } from '../models';

export class InvoiceItemsWithDynamicPropsToInvoiceItems {
    transform(invoiceItems: InvoiceItemWithDynamicProps[]): Partial<InvoiceItem>[] {
        return invoiceItems.map((invoiceItem) => {
            const item: InvoiceItemWithDynamicProps = new Transformers.ToPlainTransformer().transform(invoiceItem);

            if (!item.pimsGeneratedId) {
                item.pimsGeneratedId = item.pimsId;
            }

            item.discounts = item.discounts?.map((d) => pick(d, ['id', 'departmentCode', 'description', 'percentage']));

            this.removeRoundToIfAutoCalculatePriceIsDisabled(item);
            this.removeDynamicProps(item);
            this.updateOmitDispensingFee(item);
            return item;
        });
    }

    private removeDynamicProps(item: InvoiceItemWithDynamicProps): void {
        // These are carried over from the base level item
        delete item.sites;
        delete item.providers;

        // These properties are set with React Final Form components/methods
        delete item.validateOnly;
    }

    private removeRoundToIfAutoCalculatePriceIsDisabled(item): void {
        if (item.prices?.autoCalculatePrice?.id === AutoCalculatePrice.DoNotAutoCalculatePrice) {
            item.prices.roundTo = null;
        }
    }

    private updateOmitDispensingFee(item): void {
        if (item.itemType?.id !== InvoiceItemTypes.Inventory && item?.prices) {
            item.prices.omitDispensingFeeForMultiplePatients = false;
        }
    }
}
